<template>
  <div class="plthumb grid">
    <router-link :to='"/browse/building/"+building.slug' v-if='lazy'><img v-lazy="'https://img.therenees.com/'+building.photo" /></router-link>
    <router-link :to='"/browse/building/"+building.slug' v-if='!lazy'><img :src="'https://img.therenees.com/'+building.photo" /></router-link>



    <h4>{{building.name}}</h4>
  </div>
</template>

<script>
export default {
  name: 'BuildingThumb',
  props: [
    'building',
    'lazy'
  ],
  watch: {
  },
  data () {
    return {
    }
  },
  mounted: function () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/_mixins.scss";
.plthumb {
/*   transition: width .1s; */
  margin-bottom: .5%;
  line-height: 0;
  position: relative;
  h4 {
    line-height: 1;
    font-weight: 500;
    position: absolute;
    text-align: left;
    left: 0px;
    top: 0px;
    color: #FFF;
    margin: 0px;
    padding: .35em;
    z-index: 10;
    font-size: 14px;
    width: 80%;
    background: linear-gradient(90deg, rgba(161,99,165,1) 0%, rgba(161,99,165,0) 100%);
    @include bp(most) {
      font-size: 16px;
    }
  }
}
.plthumb.grid {
  display: inline-block;
/*
  width: 24.5%;
  max-height: 16vw;
*/
  width: 49%;
  height: 30vw;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;

  }
  @include bp(most) {
    width: 32.7%;
    height: 21vw;
  }
  @include bp(large) {
    width: 24%;
    height: 15.7vw;
  }
}
.plthumb.full {
 width: 100%;
/*  height:  66.808vw; */

 img {
    width: 100%;
 }
 .VueCarousel-wrapper {
   height:  65.5vw;
 }
}
img {
/*   height: 100%; */
}
.overlay-container {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 1;
  pointer-events: none;
  display: none;
  @include bp(most) {
    display: block;
  }
  .bottom-overlay {
    pointer-events: auto;
    position: absolute;
    bottom: 0px;
    width: 100%;
    left: 0px;
    color: $yellow;
    opacity: 0;
    transition: opacity .5s;
    /* background: rgba(0,0,0,.75); */
    /* transition: bottom .25s; */
    padding-left: .25em;
    box-sizing: border-box;
    span {
      display: inline-block;
      line-height: 1.75;
      font-size: 1.25em;
      padding-left: .25em;
      vertical-align: middle;
      cursor: pointer;
      &.added {
        cursor: default;
      }
    }
    .pullsheet-tooltip {
      position: absolute;
      left: 2em;
      top: 0px;
      line-height: 2;
      width: 16em;
      overflow: hidden;
      height: 2em;
      cursor: pointer;
      &.added {
        cursor: default;
      }
      span {
        display: block;
        position: absolute;
        left: -16em;
        transition: left .25s;
      }
    }
    &:hover .pullsheet-tooltip span {
      left: .825em;
      &.added {
        left: 2.25em;
      }
    }
  }
  .next-button, .previous-button {
    pointer-events: auto;
    position: absolute;
    background: rgba(161,99,165,.5);
    line-height: 1;
    padding: 0;
    color: #FFF;
    top: 45%;
    margin-top: -12px;
		@include noselect();
		cursor: pointer;
		i {
      font-size: 36px;
  		vertical-align: middle;
		}
/*
    .full & {
      i {
        font-size: 64px;
      }
    }
*/
  }
  .next-button {
    transition: right .25s;
    right: -38px;
  }
  .previous-button {
    transition: left .25s;
    left: -38px;
  }
  .plthumb.initialized:hover & .bottom-overlay, .plthumb.addedtosheet & .bottom-overlay {
    /* bottom: 0px; */
    opacity: 1;
  }
  .plthumb.initialized:hover & .next-button {
    right: 0px;
  }
  .plthumb.initialized:hover & .previous-button {
    left: 0px;
  }

}
.difficulty-indicators {
  position: absolute;
  z-index: 5;
  top: 0px;
  right: 0px;
  width: 100px;
  font-size: 0px;
  text-align: right;
  div {
    display: inline-block;
    height: 16px;
    width: 16px;
    margin: 5% 5% 0 0;
    vertical-align: middle;
    border-radius: 16px;
    border: 1px solid #EEE;
    &.green {
      background-color: #2ecc40;
      border-color: #2ecc40;
    }
    &.orange {
      background-color: #ff851b;
      border-color: #ff851b;
    }
    &.red {
      background-color: #ef1607;
      border-color: #ef1607;
    }
    &.yellow {
      background-color: #ffe21f;
      border-color: #ffe21f;
    }
  }
}
</style>
<style lang="scss">
.plthumb.full {
 .VueCarousel-wrapper {
   height:  65.5vw;
 }
}
</style>



// WEBPACK FOOTER //
// BuildingThumb.vue?96468d5a